import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, CheckCircle } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function ForgotPasswordPage() {
  const [nif, setNif] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await axios.post(`${API}/auth/forgot-password`, { nif: nif.trim() });
      setSent(true);
    } catch (err) {
      setError(err?.response?.data?.detail || "Erro ao enviar pedido.");
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <main className="pt-32 pb-20 bg-stone-50 min-h-screen">
        <div className="max-w-md mx-auto px-6">
          <div className="bg-white rounded-2xl shadow-xl border border-stone-100 p-8 text-center">
            <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-stone-900 mb-2">Email Enviado!</h1>
            <p className="text-stone-500 mb-6">
              Se o NIF <strong>{nif}</strong> estiver registado, receberás um link para redefinir a tua password.
            </p>
            <p className="text-sm text-stone-400 mb-6">
              Verifica a tua caixa de entrada e a pasta de spam. O link expira em 1 hora.
            </p>
            <Link to="/area-socio/login" className="inline-flex items-center gap-2 text-brand-700 font-semibold hover:text-brand-800">
              <ArrowLeft className="w-4 h-4" /> Voltar ao login
            </Link>
          </div>
        </div>
      </main>
    );
  }

  return (
    <main className="pt-32 pb-20 bg-stone-50 min-h-screen">
      <div className="max-w-md mx-auto px-6">
        <Link to="/area-socio/login" className="inline-flex items-center gap-2 text-sm text-stone-500 hover:text-brand-700 transition-colors mb-8">
          <ArrowLeft className="w-4 h-4" /> Voltar ao login
        </Link>

        <div className="bg-white rounded-2xl shadow-xl border border-stone-100 p-8">
          <h1 className="text-2xl font-bold text-stone-900 mb-2 text-center">Recuperar Password</h1>
          <p className="text-stone-500 text-sm text-center mb-6">
            Introduz o teu NIF para receberes um link de recuperação.
          </p>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="text-sm font-medium text-stone-700 mb-1.5 block">NIF</label>
              <input
                required
                type="text"
                inputMode="numeric"
                maxLength={9}
                value={nif}
                onChange={e => setNif(e.target.value)}
                placeholder="123456789"
                className="w-full h-10 px-3 rounded-md border border-stone-200 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent"
              />
            </div>

            {error && <p className="text-sm text-red-600">{error}</p>}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-brand-700 hover:bg-brand-800 disabled:opacity-60 text-white rounded-full py-3 font-semibold"
            >
              {loading ? "A enviar..." : "Enviar link de recuperação"}
            </button>
          </form>
        </div>
      </div>
    </main>
  );
}
